module.exports = __webpack_public_path__ + "img/LogoWithDarkText.d2ece3f1.svg";